<template>
  <div>
    <v-dialog v-model="showUpload" width="500">
      <template>
        <Upload url="/category/import" @close="showUpload = false;" @success="showUpload = false; load()"/>
      </template>
    </v-dialog>

    <v-row class="mb-1">
      <v-col>
        <v-btn block type="button" color="primary" v-on:click="exportExcel()">
          EXPORT
        </v-btn>
      </v-col>

      <v-col>
        <v-btn block type="button" color="primary" v-on:click="showUpload = true">
          IMPORT
        </v-btn>
      </v-col>

      <v-col>
        <router-link to="/categories/manage">
          <v-btn block type="button" color="primary">
            ADD NEW CATEGORY
          </v-btn>
        </router-link>
      </v-col>
    </v-row>

    <!-- <div class="d-flex mb-5">
      <v-btn type="button" color="primary" v-on:click="exportExcel()">
        EXPORT
      </v-btn>

      <v-btn type="button" color="primary" style="margin-left: 10px" v-on:click="showUpload = true">
        IMPORT
      </v-btn>

      <v-spacer></v-spacer>

      <router-link to="categories/manage">
        <v-btn type="button" color="primary">
          ADD NEW CATEGORY
        </v-btn>
      </router-link>
    </div> -->

    <div class="filters">
      <SearchBar label='Search...' @search="search = $event"/>

      <div class="filter">
        <v-select 
          :items="sortedCategories" 
          item-text="name" 
          item-value="id"
          v-model="filteredCategory" 
          return-object 
          label="Category" 
          @change="load()" 
          hide-details
          density="compact"/>
      </div>

      <div class="filter">
        <v-checkbox 
          v-model="topLevelCategoriesOnly" 
          @change="load()"
          label="Top Level Categories Only" 
          class="ma-0 pa-0" 
          hide-details>
        </v-checkbox>
      </div>
    </div>

    <div v-if="$vuetify.breakpoint.smAndDown" class="category-mobile-list">
      <div v-if="isLoading" class="category-mobile-list__loading">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>

      <v-alert v-else-if="displayedCategories.length === 0" text type="info">
        No categories found.
      </v-alert>

      <v-card v-for="category in displayedCategories" v-else :key="category.id" class="category-card" outlined>
        <div class="category-card__main">
          <img v-if="category.imageUrlThumbnail != null" :src="imageUrl + category.imageUrlThumbnail" alt="" />
          <div v-else class="category-card__image-placeholder">
            <v-icon>mdi-shape</v-icon>
          </div>

          <div class="category-card__title">
            <h3>{{ category.name }}</h3>
            <span>{{ parentCategoryName(category) }}</span>
          </div>
        </div>

        <p v-if="category.description" class="category-card__description">{{ category.description }}</p>

        <div class="category-card__meta">
          <div v-if="category.popupNotes">
            <span>Popup notes</span>
            <strong>{{ category.popupNotes }}</strong>
          </div>
          <div>
            <span>Age check</span>
            <strong>{{ category.ageCheck ? 'Yes' : 'No' }}</strong>
          </div>
          <div>
            <span>Discount</span>
            <strong>{{ category.isExcludedFromDiscount ? 'Excluded' : 'Allowed' }}</strong>
          </div>
        </div>

        <div class="category-card__actions">
          <v-spacer></v-spacer>
          <v-btn icon color="secondary" :to="`/categories/manage/${category.id}`" aria-label="Edit category">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon color="error" aria-label="Delete category" @click="remove(category)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </v-card>
    </div>

    <v-data-table
      v-if="$vuetify.breakpoint.mdAndUp"
      :headers="headers" :items="filteredCategories" :search="search" 
      :loading="isLoading"
      item-key="name" class="elevation-1 mt-5">

      <template v-slot:body="props">
        <draggable :list="props.items" tag="tbody" :disabled="!draggableEnabled" :move="onMoveCallback" :clone="onCloneCallback" @end="onDropCallback">
          <data-table-row-handler
            v-for="(item, index) in props.items"
            :key="index"
            :item="item"
            :headers="headers">

            <template v-slot:[`item.sort`]="{ item }">
              <v-icon v-if="draggableEnabled" style="cursor: pointer">mdi-drag</v-icon>
            </template>

            <template v-slot:[`item.image`]="{ item }">
              <img v-if="item.imageUrlThumbnail != null" :src="imageUrl + item.imageUrlThumbnail" />
            </template>

            <template v-slot:[`item.ageCheck`]="{ item }">
              <div v-if="item.ageCheck">YES</div>
              <div v-if="!item.ageCheck">NO</div>
            </template>

            <template v-slot:[`item.isExcludedFromDiscount`]="{ item }">
              <div v-if="item.isExcludedFromDiscount">YES</div>
              <div v-if="!item.isExcludedFromDiscount">NO</div>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <router-link :to="`/categories/manage/${item.id}`">
                <v-icon small class="mr-2">mdi-pencil</v-icon>
              </router-link>
              <v-icon small @click="remove(item)">mdi-delete</v-icon>
            </template>

          </data-table-row-handler>
        </draggable>
      </template>


      <!-- <template v-slot:[`item.image`]="{ item }">
        <img v-if="item.imageUrlThumbnail != null" :src="imageUrl + item.imageUrlThumbnail" />
      </template>

      <template v-slot:[`item.ageCheck`]="{ item }">
        <div v-if="item.ageCheck">YES</div>
        <div v-if="!item.ageCheck">NO</div>
      </template>

      <template v-slot:[`item.isExcludedFromDiscount`]="{ item }">
        <div v-if="item.isExcludedFromDiscount">YES</div>
        <div v-if="!item.isExcludedFromDiscount">NO</div>
      </template>

       <template v-slot:[`item.actions`]="{ item }">
        <router-link :to="`/categories/manage/${item.id}`">
          <v-icon small class="mr-2">mdi-pencil</v-icon>
        </router-link>
        <v-icon small @click="remove(item)">mdi-delete</v-icon>
      </template> -->
    </v-data-table>
  </div>
</template>

<script>
  import SearchBar from '@/components/SearchBar.vue';
  import Upload from '@/components/Upload.vue';
   import DataTableRowHandler from '@/components/table/DataTableRowHandler';
  import draggable from "vuedraggable";

  import { categoryService } from '@/services';
  import { saveAs } from 'file-saver';
  import { b64toBlob } from '@/helpers'

  export default {
    name: 'Categories',
    components: {
      SearchBar,
      Upload,
      DataTableRowHandler,
      draggable,
    },
    data: () => ({
      imageUrl: process.env.VUE_APP_APIURL.substring(0, process.env.VUE_APP_APIURL.length - 3),
      isLoading: false,
      sortedCategories: [],
      categories: [],
      filteredCategories: [],
      search: "",
      filteredCategory: null,
      topLevelCategoriesOnly: false,
      headers: [
        { text: '', align: 'start', sortable: false, filterable: false, value: 'sort', width: 40 },
        { text: '', align: 'start', sortable: false, filterable: false, value: 'image', width: 80 },
        { text: 'Name', align: 'start', sortable: true, filterable: true, value: 'name' },
        { text: 'Description', align: 'start', sortable: true, filterable: true, value: 'description' },
        { text: 'Parent Category', align: 'start', sortable: true, filterable: true, value: 'parentCategory.name' },
        { text: 'Popup Notes', align: 'start', sortable: true, filterable: true, value: 'popupNotes' },
        { text: 'Age Check', align: 'start', sortable: true, filterable: true, value: 'ageCheck' },
        { text: 'Is Excluded From Discount', align: 'start', sortable: true, filterable: true, value: 'isExcludedFromDiscount' },
        { text: 'Actions' , align: 'end', value: 'actions' }
      ],

      showUpload: false,

      movedElement: null,
    }),
    created () {
      this.load();
    },
    methods: {
      load: async function() {
        this.isLoading = true;
        this.categories = await categoryService.get();

        // Create our filter drop down
        var sortedCategories = [];
        for (let category of [...this.categories].sort((a, b) => a.name.localeCompare(b.name))) {
          if (category.parentCategoryId == null ) {
            sortedCategories.push({ header: category.name, divider: true });
          }
          sortedCategories.push(category);
        }
        
        sortedCategories.unshift({ 
          id: null,
          name: "All"
        });

        this.sortedCategories = sortedCategories;

        this.filteredCategories = this.categories;
        if (this.topLevelCategoriesOnly) { 
          this.filteredCategories = this.categories.filter(c => c.parentCategoryId == null);
        }
        if (this.filteredCategory != null && this.filteredCategory.id != null) {
          this.filteredCategories = this.filteredCategories.filter(c => c.parentCategoryId == this.filteredCategory.id);
        }
        
        this.isLoading = false;
      },
      remove: async function(category) {
        this.isLoading = true;
        var response = await categoryService.remove(category.id);
        this.isLoading = false;
        if (response.status != 200) {
          alert("Error deleting");
          return;
        }

        this.load();
      },
      exportExcel: async function() {
        this.isLoading = true;
        var response = await categoryService.exportExcel();
        if (response.status != 200) {
          alert("Error exporting");
          return;
        }

        var base64 = await response.json();
        const blob = b64toBlob(base64, 'application/vnd.ms-excel');
        saveAs(blob, 'Categories.xls');

        this.isLoading = false;
      },
      onCloneCallback(item) {
        // Create a fresh copy of item
        const cloneMe = JSON.parse(JSON.stringify(item));
        return cloneMe;
      },
      onMoveCallback(evt, originalEvent) {
        const item = evt.draggedContext.element;
        this.movedElement = item;
        return true;
      },
      onDropCallback(evt, originalEvent) {
        const newPosition = evt.newIndex + 1;
        this.movedElement.position = newPosition;
        categoryService.update(this.movedElement);
      },
      parentCategoryName(category) {
        if (category.parentCategory && category.parentCategory.name) {
          return category.parentCategory.name;
        }

        return 'Top level category';
      }
    },
    computed: {
      draggableEnabled() {
        if (this.topLevelCategoriesOnly)
          return true;

        if (this.filteredCategory != null && this.filteredCategory.id != null)
          return true;

        return false;
      },
      displayedCategories() {
        if (!this.search || this.search.trim() === "") {
          return this.filteredCategories;
        }

        const search = this.search.toLowerCase();
        return this.filteredCategories.filter(category => {
          return (
            category.name?.toLowerCase().includes(search) ||
            category.description?.toLowerCase().includes(search) ||
            category.parentCategory?.name?.toLowerCase().includes(search) ||
            category.popupNotes?.toLowerCase().includes(search)
          );
        });
      }
    }
  }
</script>

<style scoped>
  .category-mobile-list {
    display: grid;
    gap: 12px;
    margin-top: 14px;
  }

  .category-mobile-list__loading {
    align-items: center;
    display: flex;
    justify-content: center;
    min-height: 180px;
  }

  .category-card {
    display: grid;
    gap: 12px;
    padding: 14px;
  }

  .category-card__main {
    align-items: center;
    display: grid;
    gap: 12px;
    grid-template-columns: 52px minmax(0, 1fr);
  }

  .category-card__main img,
  .category-card__image-placeholder {
    aspect-ratio: 1;
    border-radius: 8px;
    width: 52px;
  }

  .category-card__main img {
    object-fit: cover;
  }

  .category-card__image-placeholder {
    align-items: center;
    background: #effaf8;
    border: 1px solid #d5ebe7;
    display: flex;
    justify-content: center;
  }

  .category-card__image-placeholder .v-icon {
    color: #0f766e;
  }

  .category-card__title {
    min-width: 0;
  }

  .category-card__title h3 {
    color: #111827;
    font-size: 16px;
    font-weight: 800;
    line-height: 1.25;
    margin: 0;
    overflow-wrap: anywhere;
  }

  .category-card__title span {
    color: #64748b;
    display: block;
    font-size: 12px;
    margin-top: 3px;
  }

  .category-card__description {
    color: #475569;
    font-size: 13px;
    margin: 0;
  }

  .category-card__meta {
    display: grid;
    gap: 8px;
    grid-template-columns: 1fr;
  }

  .category-card__meta > div {
    background: #f8fafc;
    border: 1px solid #dfe7ef;
    border-radius: 8px;
    min-width: 0;
    padding: 9px;
  }

  .category-card__meta span {
    color: #64748b;
    display: block;
    font-size: 10px;
    font-weight: 800;
    text-transform: uppercase;
  }

  .category-card__meta strong {
    color: #111827;
    display: block;
    font-size: 13px;
    line-height: 1.25;
    margin-top: 3px;
    overflow-wrap: anywhere;
  }

  .category-card__actions {
    align-items: center;
    border-top: 1px solid #dfe7ef;
    display: flex;
    gap: 4px;
    padding-top: 4px;
  }

  .category-card__actions .v-btn {
    box-shadow: none !important;
  }
</style>
